import axios from 'axios';
import _ from 'lodash';

export function getCurrentUserDetails(user) {
  return dispatch => {
    dispatch({type: 'USERDETAILS_FETCHING'});
    if (user.username && user.stronglyIdentified) {
      let contactDetails;
      axios.get('/api/user/contactdetails')
        .then(
          response => {
            contactDetails = response.data;
            return axios.get('/maksukanavat/api/userProductData');
          }
        ).then(
        response => {
          const devices = _.get(response, 'data.devices', []);
          const products = _.get(response, 'data.products', []);
          const data = {...contactDetails, devices, products};
          dispatch({type: 'USERDETAILS_FETCHED', data});
        }
      )
        .catch(err => {
          dispatch({type: 'USERDETAILS_ERROR', data: err});
        });
    } else {
      dispatch({type: 'USERDETAILS_FETCHED', data: {}});
    }
  };
}

export function resetUserDetails() {
  return dispatch => dispatch({type: 'USERDETAILS_RESET'});
}



// WEBPACK FOOTER //
// ./web/js/stores/actions/userDetails.js